import { StackProps as MuiStackProps } from '@mui/material/Stack';
import Typography from '../../../../../../shared/library/Typography';
import { MuiStack } from '../../../../../../../../modules/material';

export interface ListHeadingProps extends MuiStackProps {
  title: string;
  subTitle?: string;
}

export default function ListHeading(props: ListHeadingProps) {
  const { title, subTitle, children, ...stackProps } = props;

  return (
    <MuiStack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-end"
      {...stackProps}
    >
      <div>
        <Typography variant="subtitle2" neutralColorIndex={700}>
          {title}
        </Typography>
        {subTitle && (
          <Typography variant="smallText" neutralColorIndex={700}>
            {subTitle}
          </Typography>
        )}
      </div>

      {children}
    </MuiStack>
  );
}
